import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import Flexbox from 'flexbox-react';
import * as actions from '../actions';
import io from '../utils/socket-client';

let socket;

class Auth extends Component {
    constructor(props){
        super(props);
        this.state = {tokenExist: true}
    }

    componentDidMount() {
        let token = window.localStorage.getItem('token');
        console.log('get token: ', token);
        if (token) {
            this.connect({access_token: token});
        } else {
            this.setState({tokenExist: false});
        }
    }


    authorization() {
        this.props.showLoader();
        let self = this;
            fetch(io.SERVER_URL_AUTH + '/api/oauth/token',
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        grant_type: 'password',
                        client_id: 'web-client',
                        client_secret: 'skd934kd04md',
                        username: self.refs.login.value,
                        password: self.refs.password.value,
                    }),
                })
                .then(res => {
                    res.json().then(
                        data => {
                            this.connect(data);
                        },
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
    }

        connect(data){
        let self = this;
            io.setContext(this.props.context);
            io.setHeader('authorization', data.access_token);
            socket = io.connect(io.SERVER_URL);
            if(socket){
                io.socketFetch('admin', {},
                    res=>{
                        console.log(res);
                        self.props.onLoadData(res);
                    },
                    (res) =>{
                        self.props.hideLoader();
                        if(res && res.error) {
                            console.log('error: ', res.error);
                            if(res.error === 'access denied'){
                                self.props.setError('Доступ запрещен!');
                            } else if(res.error === 'unauthorized'){
                                window.localStorage.removeItem('token');
                                console.log('remove token');
                                window.location.href = window.location.href;
                            } else {
                                self.props.setError('Упс, что-то пошло не так... Попробуйте снова!');
                            }
                        } else {
                            self.props.onChangeAuthState(true);
                            window.localStorage.setItem('token', data.access_token);
                            console.log('set token: ', data.access_token);
                            self.props.clearError();
                        }
                    });
            }
        }

    onAuthSubmit(event){
        this.authorization();
        event.preventDefault();
    }

  render() {
    return (
        <Flexbox style={style.container}>
            <Helmet title="Авторизация"/>
            {this.state.tokenExist
                ?
                false
                :
                <form ref="auth_form" method="post" onSubmit={this.onAuthSubmit.bind(this)}>
                    <Flexbox style={style.formInputContainer}>
                        <input ref={"login"} style={style.input} type="text" name="login" required={true} placeholder="Логин" autoComplete="off" spellCheck={false}/>
                        <input ref={"password"} style={style.input} type="password" name="password" required={true} placeholder="Пароль" minLength={6}/>
                        <button type="submit" style={style.input}>Войти</button>
                    </Flexbox>
                </form>
            }
        </Flexbox>
    )
  }
}

const style = {
    input: {
        fontSize: 20
    },

    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: "98vh",
    },

    formInputContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around',
        minWidth: 300,
        minHeight: 150,
        padding: 10,
        border: 'solid #000 2px'
    }
};

function mapDispatchToProps(dispatch) {
    return {
        onChangeAuthState: (authState) => {
            dispatch(actions.changeAuthState(authState));
        },
        onLoadData: (data) => {
            dispatch(actions.setData(data))
        },
        setError: (error) => {
            dispatch(actions.setError(error));
        }
    };
}

export default connect(null, mapDispatchToProps)(Auth);


// WEBPACK FOOTER //
// ./src/containers/Auth.js